import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'

const UNCHANGED = 'unchanged'

const Keys = {
  ADD_BANKS: 'add_banks',
  SET_ALL_AS_UNCHANGED: 'set_all_as_unchanged',
  CLEAR: 'clear'
}

export const state = {
  banks: []
}
export const mutations = {
  [Keys.ADD_BANKS](state, banks) {
    if (!banks || !banks.length) {
      return
    }

    state.banks = banks
  },

  [Keys.SET_ALL_AS_UNCHANGED](state) {
    for (let bank of state.banks) {
      bank.rowState = UNCHANGED
    }
  },

  [Keys.CLEAR](state) {
    state.banks = []
  }
}
export const actions = {
  async refresh({ dispatch, commit, state }, options) {
    options = _.extend({ force: false }, options)

    // clear
    commit(Keys.CLEAR)

    var key = 'data-banks'

    if (options.force !== true) {
      var cached = await dispatch('cache/get', key, { root: true })
      if (cached != null) {
        commit(Keys.ADD_BANKS, cached)
        return
      }
    }

    var result = await post(Endpoints.getUrl('bank.list'))
    if (result.success) {
      var cacheObj = {
        key,
        seconds: 24 * 60 * 60,
        value: result.data.items
      }

      dispatch('cache/set', cacheObj, { root: true })
      commit(Keys.ADD_BANKS, cacheObj.value)
    }
  },

  async modify({ dispatch, commit, state }, banks) {
    commit(Keys.ADD_BANKS, banks)

    let updates = state.banks.filter(x => x.rowState !== UNCHANGED).map(x=>{
      delete x.code
      return{
        ...x
      }
    })
    let result = await post(Endpoints.getUrl('bank.modify'), { items: updates })
    if (result.success) {
      commit(Keys.SET_ALL_AS_UNCHANGED)
      dispatch('socket/broadcastRefresh', 'Bank', { root: true })
    }
  },

  clear({ commit }) {
    commit(Keys.CLEAR)
  }
}
export const getters = {
  all: state => {
    return state.banks
  },
  getById: state => id => {
    return _.head(state.banks.filter(x => x.id === id))
  },
  derties: state => {
    return state.banks.filter(item => item.rowState !== UNCHANGED)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
